// USER
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILURE = 'LOGIN_FAILURE';
const LOGOUT = 'LOGOUT';
const SET_TOKEN = 'SET_TOKEN';
const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';
const SET_LOADING_USER = 'SET_LOADING_USER';
const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
const GET_USER_FAILURE = 'GET_USER_FAILURE';
const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

// INFORMATION
const GET_INFO_GENERAL_SUCCESS = 'GET_INFO_GENERAL_SUCCESS';
const GET_INFO_GENERAL_FAILURE = 'GET_INFO_GENERAL_FAILURE';
const SET_LOADING_INFO = 'SET_LOADING_INFO';

// DOCTORS
const GET_DOCTOR_SUCCESS = 'GET_DOCTOR_SUCCESS';
const GET_DOCTOR_FAILURE = 'GET_DOCTOR_FAILURE';
const SAVE_DOCTOR = 'SAVE_DOCTOR';

// HEALTH INSURANCE
const GET_HEALTH_INSURANCE_SUCCESS = 'GET_HEALTH_INSURANCE_SUCCESS';
const GET_HEALTH_INSURANCE_FAILURE = 'GET_HEALTH_INSURANCE_FAILURE';
const SAVE_HEALTH_INSURANCE = 'SAVE_HEALTH_INSURANCE';

const GET_DATES_SUCCESS = 'GET_DATES_SUCCESS';
const GET_DATES_FAILURE = 'GET_DATES_FAILURE';
const SAVE_DATES = 'SAVE_DATES';
const GET_HOURS_SUCCESS = 'GET_HOURS_SUCCESS';
const GET_HOURS_FAILURE = 'GET_DATES_FAILURE';
const SAVE_HOURS = 'SAVE_HOURS';
const SET_LOADING = 'SET_LOADING';
const GET_CONFIRM_SUCCESS = 'GET_CONFIRM_SUCCESS';
const GET_CONFIRM_FAILURE = 'GET_CONFIRM_FAILURE';
const SAVE_CONFIRM_SUCCESS = 'SAVE_CONFIRM_SUCCESS';
const SAVE_CONFIRM_FAILURE = 'SAVE_CONFIRM_FAILURE';
const EMPTY_ERROR = 'EMPTY_ERROR';
const CANCEL_TURN_SUCCESS = 'CANCEL_TURN_SUCCESS';
const CANCEL_TURN_FAILURE = 'CANCEL_TURN_FAILURE';

// NOTIFICATION
const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';
const GET_NOTIFICATION_FAILURE = 'GET_NOTIFICATION_FAILURE';

// Questions
const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';
const GET_QUESTION_FAILURE = 'GET_QUESTION_FAILURE';
const SAVE_QUESTION_SUCCESS = 'SAVE_QUESTION_SUCCESS';
const SAVE_QUESTION_FAILURE = 'SAVE_QUESTION_FAILURE';
const SAVE_RESET = 'SAVE_RESET';

export {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SET_TOKEN,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_INFO_GENERAL_SUCCESS,
  GET_INFO_GENERAL_FAILURE,
  GET_DOCTOR_SUCCESS,
  GET_DOCTOR_FAILURE,
  SAVE_DOCTOR,
  GET_HEALTH_INSURANCE_SUCCESS,
  GET_HEALTH_INSURANCE_FAILURE,
  SAVE_HEALTH_INSURANCE,
  GET_DATES_SUCCESS,
  GET_DATES_FAILURE,
  SAVE_DATES,
  SET_LOADING_INFO,
  GET_HOURS_SUCCESS,
  GET_HOURS_FAILURE,
  SAVE_HOURS,
  GET_CONFIRM_SUCCESS,
  GET_CONFIRM_FAILURE,
  SET_LOADING,
  SET_LOADING_USER,
  EMPTY_ERROR,
  SAVE_CONFIRM_SUCCESS,
  SAVE_CONFIRM_FAILURE,
  CANCEL_TURN_SUCCESS,
  CANCEL_TURN_FAILURE,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAILURE,
  GET_QUESTION_SUCCESS,
  GET_QUESTION_FAILURE,
  SAVE_QUESTION_SUCCESS,
  SAVE_QUESTION_FAILURE,
  SAVE_RESET,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
};
